export type CommunityLinkPlatform = 'line' | 'facebook' | 'instagram' | 'website' | 'tiktok'
export type CommunityLinkCategory = 'world_community' | 'support_line' | 'support_facebook' | 'medical_resource' | 'international_nurse'
export type CommunityLinkGender = 'male' | 'female'

export interface CommunityLink {
  id: string
  title: string
  description: string
  url: string
  imageUrl?: string
  platform: CommunityLinkPlatform
  category: CommunityLinkCategory
  order: number
  isActive: boolean
  country?: string // ISO 3166-1 alpha-2, e.g. 'TW', 'JP'
  gender?: CommunityLinkGender
  createdAt: Date
  updatedAt?: Date
}

export interface CreateCommunityLinkInput {
  title: string
  description: string
  url: string
  imageUrl?: string
  platform: CommunityLinkPlatform
  category: CommunityLinkCategory
  order?: number
  country?: string
  gender?: CommunityLinkGender
}

export interface UpdateCommunityLinkInput extends Partial<CreateCommunityLinkInput> {
  isActive?: boolean
}

export const PlatformLabels: Record<CommunityLinkPlatform, string> = {
  line: 'LINE',
  facebook: 'Facebook',
  instagram: 'Instagram',
  website: '網站',
  tiktok: 'TikTok',
}

export const CategoryLabels: Record<CommunityLinkCategory, string> = {
  world_community: '世界護理人員交流',
  support_line: 'Line 社群',
  support_facebook: 'FB 社團',
  medical_resource: '醫療專業資源庫',
  international_nurse: '國際護理師',
}

export const CountryLabels: Record<string, string> = {
  TW: '🇹🇼 台灣',
  JP: '🇯🇵 日本',
  KR: '🇰🇷 韓國',
  SG: '🇸🇬 新加坡',
  PH: '🇵🇭 菲律賓',
  US: '🇺🇸 美國',
  CA: '🇨🇦 加拿大',
  GB: '🇬🇧 英國',
  AU: '🇦🇺 澳洲',
  DE: '🇩🇪 德國',
}

export const GenderLabels: Record<CommunityLinkGender, string> = {
  male: '男性',
  female: '女性',
}
